import PlaySessionTypes from "@Enums/PlaySessionTypes";
import { Box, useMediaQuery, useTheme } from "@mui/material";

import Icon from "@Components/generic/icon";
import { getMetricPrimaryColor, getMetricSecondaryColor } from "@Containers/app/stat-cards/tooltips/get-metric-colors";
import { faCourtSport, faSquarePollVertical } from "@fortawesome/pro-regular-svg-icons";
import SportsSoccerOutlinedIcon from "@mui/icons-material/SportsSoccerOutlined";
import { faChallenge } from "@Resources/app/icons/activity";

const SessionTypeIcon = ({
  sessionType,
  gameMode,
  size = 6,
}: {
  sessionType: PlaySessionTypes;
  gameMode: string;
  size?: number;
}) => {
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));

  let icon: React.ReactElement = (
    <SportsSoccerOutlinedIcon
      sx={{ color: getMetricPrimaryColor(sessionType, theme) }}
      fontSize={isSmUp ? "large" : "medium"}
    />
  );

  switch (sessionType) {
    case PlaySessionTypes.PRACTISE_SESSION:
      icon = (
        <Icon
          icon={faSquarePollVertical}
          color={getMetricPrimaryColor(sessionType, theme)}
          fontSize={isSmUp ? theme.spacing(4) : theme.spacing(2.5)}
        />
      );
      break;
    case PlaySessionTypes.CHALLENGE_SESSION:
      icon = (
        <Icon
          icon={faChallenge}
          color={getMetricPrimaryColor(sessionType, theme)}
          fontSize={isSmUp ? theme.spacing(4.5) : theme.spacing(2.5)}
        />
      );
      break;
    default:
      break;
  }

  if (gameMode === "MATCH_PLAY") {
    icon = (
      <Icon
        icon={faCourtSport}
        color={getMetricPrimaryColor(sessionType, theme)}
        fontSize={isSmUp ? theme.spacing(4.5) : theme.spacing(2.5)}
        transform={"rotate-90"}
      />
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "25%",
        width: theme.spacing(size),
        height: theme.spacing(size),
        backgroundColor: getMetricSecondaryColor(sessionType, theme),
      }}
    >
      {icon}
    </Box>
  );
};

export default SessionTypeIcon;
